/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'detectedDpi'?: GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'calculatedDpi'?: GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'colorGradation'?: GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'heightMillis'?: GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors
     */
    'widthMillis'?: GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum;
}

export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsDetectedDpiEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsCalculatedDpiEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsColorGradationEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsHeightMillisEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrorsWidthMillisEnum];


